import { HONEYPOT_FIELD_NAME } from "@/lib/public-form-honeypot";

/**
 * The hidden anti-bot field for public forms. Visually hidden, off the tab
 * order and ignored by assistive tech; people never fill it, bots that fill
 * every input trip the server. Read it back with
 * `formData.get(HONEYPOT_FIELD_NAME)` and post it under the same key.
 *
 * The name is neutral on purpose (see `lib/public-form-honeypot.ts`), and the
 * `data-*` attributes tell the common password managers to leave it alone —
 * `autoComplete="off"` alone is ignored by Chrome for profile-shaped fields.
 */
export function HoneypotField({ id }: { id: string }) {
  return (
    <div aria-hidden="true" className="sr-only">
      <label htmlFor={id}>Leave this field empty</label>
      <input
        id={id}
        name={HONEYPOT_FIELD_NAME}
        type="text"
        tabIndex={-1}
        autoComplete="off"
        defaultValue=""
        data-lpignore="true"
        data-1p-ignore="true"
        data-form-type="other"
      />
    </div>
  );
}
